export const DEFAULT_COLUMNS = [
  "business_unit",
  "product_hierarchy",
  "geography",
  "base_sale",
  "brand_marketing_sale",
  "category_marketing_sale",
  "earned_sale",
  "media_sale",
  "trade_sale",
  "owned_sale",
  "price_sale",
  "control_sale",
  "error_sale",
  "base_sale_units",
  "brand_marketing_sale_units",
  "category_marketing_sale_units",
  "media_sale_units",
  "trade_sale_units",
  "owned_sale_units",
  "price_sale_units",
  "control_sale_units",
  "error_sale_units",
];
